import { THEMES } from './themes';
import { applyFontTokens } from './fonts';

/*
 * C and RADIUS are mutable singleton objects. FONTS uses stable CSS references.
 * Every component that does `import { C } from '../tokens/design'`
 * gets a reference to the SAME object. When setActiveTheme() mutates
 * the properties, the next React render cycle picks up the new values
 * automatically — no import changes required.
 */

const _default = 'secureview';

export const C      = { ...THEMES[_default].C };
// Stable CSS references update mounted and memoized views when the partner changes.
export const FONTS = {
  sans: 'var(--font-sans, Arial, sans-serif)',
  mono: "var(--font-mono, 'IBM Plex Mono', monospace)",
  heading: "var(--font-heading, 'Syne', sans-serif)",
};
export const RADIUS = { ...THEMES[_default].RADIUS };

/** Swap the active theme in-place. Call inside a React state setter to trigger re-render. */
export function setActiveTheme(themeName) {
  const theme = THEMES[themeName];
  if (!theme) return;

  // Clear existing keys then apply new ones (handles keys that exist in one theme but not the other)
  for (const k of Object.keys(C)) delete C[k];
  Object.assign(C, theme.C);

  applyFontTokens(theme.FONTS);

  for (const k of Object.keys(RADIUS)) delete RADIUS[k];
  Object.assign(RADIUS, theme.RADIUS);
}
